import { PayloadAction } from "@reduxjs/toolkit";
import { IInitialState } from "./types";

export const reducers = {};
